module.exports = __webpack_public_path__ + "img/gamesdk16.2aafae8.png";